import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNavMenuExpand({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M5.62 2h8.98c.22 0 .4.18.4.41v1.24a.4.4 0 01-.4.4H5.62a.4.4 0 01-.4-.4V2.4a.4.4 0 01.4-.41m8.98 7.14H6.81a.4.4 0 01-.4-.41V7.49a.4.4 0 01.4-.41h7.8c.21 0 .39.18.39.41v1.24a.4.4 0 01-.4.4m-8.98 3.03h8.98c.22 0 .4.18.4.41v1.24a.4.4 0 01-.4.4H5.62a.4.4 0 01-.4-.4v-1.24a.4.4 0 01.4-.41M1.53 5.2l3.3 2.65c.18.14.17.4 0 .55l-3.3 2.64c-.18.16-.53.07-.53-.39V5.6c0-.55.35-.55.53-.39" />
    </svg>
  );
}

SvgNavMenuExpand.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNavMenuExpand.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgNavMenuExpand svgRef={ref} {...props} />);
export default ForwardRef;
